<template>
  <div class="main-content-container">
    <div class="container">
      <!-- Page Header -->
      <div class="page-header row no-gutters py-4">
        <div class="col-6 text-center text-sm-left mb-0">
          <span class="text-uppercase page-subtitle">sessão</span>
          <h3 class="page-title">Tabela de Comissões</h3>
        </div>
        <!-- Page Header - Filters -->
        <div class="col-6 d-flex">
          <div class="input-group d-flex justify-content-end my-auto">
            <button
              type="button"
              class="btn btn-primary btn-sm mt-3"
              @click="OpenModalFilter()"
            >
              <i class="fas fa-filter"></i>
              {{ countFilter > 0 ? "Filtros aplicados" : "" }}
              <span v-if="countFilter > 0" class="badge badge-light">{{
                countFilter
              }}</span>
            </button>
            <button
              v-if="countFilter > 0"
              type="button"
              class="input-group-text btn-sm ml-1 mt-3"
              v-b-tooltip.hover.bottom
              title="Limpar filtros"
              @click="ResetFilter()"
            >
              <i class="fas fa-eraser"></i>
            </button>
          </div>
        </div>
      </div>

      <!-- Default Light Table -->
      <div class="row">
        <div class="col">
          <div class="card card-small mb-4">
            <div class="card-header border-bottom">
              <div class="float-left">
                <h6 class="m-0">Comissões</h6>
              </div>
              <div v-if="pagination.TotalItems > 0" class="float-right">
                <h6 class="m-0">
                  {{ pagination.TotalItems | number }}
                  {{ pagination.TotalItems > 1 ? " itens" : "item" }}
                </h6>
              </div>
            </div>
            <div class="card-body p-0 pb-3 text-center">
              <loader :is-loading="loadingList"></loader>
              <table class="table mb-0" v-if="!loadingList">
                <thead class="bg-s2p-gray-light">
                  <tr>
                    <th scope="col" class="border-0"></th>
                    <th scope="col" class="border-0 text-left">
                      Método de pagamento
                    </th>
                    <th scope="col" class="border-0">Tipo de taxa</th>
                    <th scope="col" class="border-0">Taxa</th>
                    <th scope="col" class="border-0">Comissão</th>
                    <th scope="col" class="border-0">Tipo de parceiro</th>
                    <th scope="col" class="border-0"></th>
                    <th scope="col" class="border-0"></th>
                    <th scope="col" class="border-0"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(commission, index) in commissions" :key="index">
                    <td></td>
                    <td class="text-left">
                      {{ commission.PaymentMethod.Name }}
                    </td>
                    <td>{{ commission.TaxType.Name }}</td>
                    <td v-if="commission.TaxType.Code == 1">
                      {{ commission.Tax | percentage }}
                    </td>
                    <td v-else>{{ commission.Tax | currency }}</td>
                    <td>{{ commission.Commission | percentage }}</td>
                    <td>{{ commission.PartnerType.Name }}</td>
                    <td></td>
                    <td></td>
                    <td>
                      <div class="dropdown">
                        <button
                          class="btn btn-outline-secondary dropdown-toggle"
                          type="button"
                          id="dropdownMenuButton"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                        >
                          Opções
                        </button>
                        <div
                          class="dropdown-menu"
                          aria-labelledby="dropdownMenuButton"
                        >
                          <a
                            v-if="$isAuthorize('CommissionCompetence', 'Get')"
                            class="dropdown-item"
                            href="#"
                            v-on:click="
                              GetCommissionCompetence(
                                $event,
                                commission.Id,
                                true
                              )
                            "
                          >
                            <i class="fas fa-eye mr-2"></i> Visualizar
                          </a>
                          <a
                            v-if="
                              !commission.IsRemoved &&
                              $isAuthorize('CommissionCompetence', 'Update')
                            "
                            class="dropdown-item"
                            href="#"
                            v-on:click="
                              GetCommissionCompetence($event, commission.Id)
                            "
                          >
                            <i class="fas fa-highlighter mr-2"></i> Editar
                          </a>
                          <a
                            v-if="
                              !commission.IsRemoved &&
                              $isAuthorize('CommissionCompetence', 'Delete')
                            "
                            class="dropdown-item"
                            href="#"
                            v-on:click="DeleteCommissionCompetence(index, true)"
                          >
                            <i class="fas fa-minus-square mr-2"></i> Desativar
                          </a>
                          <a
                            v-if="
                              commission.IsRemoved &&
                              $isAuthorize('CommissionCompetence', 'Delete')
                            "
                            class="dropdown-item"
                            href="#"
                            v-on:click="
                              DeleteCommissionCompetence(index, false)
                            "
                          >
                            <i class="fas fa-check-square mr-2"></i> Ativar
                          </a>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr
                    v-if="
                      commissions == undefined ||
                      commissions == null ||
                      commissions.length == 0
                    "
                  >
                    <td colspan="9">Sem registros</td>
                  </tr>
                </tbody>
              </table>

              <div class="col-12 border-top">
                <div class="pagination-nav">
                  <b-pagination
                    class="float-right"
                    v-model="pagination.PageNumber"
                    :total-rows="pagination.TotalItems"
                    :per-page="pagination.RowsPerPage"
                    aria-controls="my-table"
                  ></b-pagination>
                  <div class="float-left">
                    <d-select size="sm" v-model="pagination.RowsPerPage">
                      <option value="5">5</option>
                      <option value="10">10</option>
                      <option value="30">30</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                      <option value="200">200</option>
                      <option value="500">500</option>
                    </d-select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal
      id="mFormCommission"
      :title="modalTitle"
      centered
      :no-close-on-backdrop="true"
      :no-close-on-esc="false"
    >
      <!-- Loader -->
      <loader :is-loading="loadingModal"></loader>

      <div v-if="!loadingModal">
        <ValidationObserver tag="form" ref="CommissionsValidationForm">
          <!-- MerchantType -->
          <d-form-row>
            <d-col md="6" class="form-group">
              <label>Tipo de conta</label>
              <ValidationProvider rules="required" v-slot="{ errors, invalid }">
                <d-select
                  v-model="infoCommission.PartnerType.Code"
                  :class="validatedCommissionForm | showValidateError(invalid)"
                  :value="null"
                  :disabled="isSeeing"
                >
                  <option :value="null" selected>Selecione</option>
                  <option
                    v-for="type in partnerTypes"
                    v-bind:key="type.Code"
                    v-bind:value="type.Code"
                  >
                    {{ type.Name }}
                  </option>
                </d-select>
                <div
                  class="invalid-feedback d-block"
                  v-if="validatedCommissionForm"
                >
                  {{ errors[0] }}
                </div>
              </ValidationProvider>
            </d-col>
            <d-col md="6" class="form-group">
              <label>Método de pagamento</label>
              <ValidationProvider rules="required" v-slot="{ errors, invalid }">
                <d-select
                  v-model="infoCommission.PaymentMethod.Code"
                  :class="validatedCommissionForm | showValidateError(invalid)"
                  :value="null"
                  :disabled="isSeeing"
                >
                  <option :value="null" selected>Selecione</option>
                  <option
                    v-for="type in paymentMethods"
                    v-bind:key="type.Code"
                    v-bind:value="type.Code"
                  >
                    {{ type.Name }}
                  </option>
                </d-select>
                <div
                  class="invalid-feedback d-block"
                  v-if="validatedCommissionForm"
                >
                  {{ errors[0] }}
                </div>
              </ValidationProvider>
            </d-col>
          </d-form-row>

          <d-form-row>
            <d-col md="6" class="form-group">
              <label>Tipo de taxa</label>
              <ValidationProvider rules="required" v-slot="{ errors, invalid }">
                <d-select
                  v-model="infoCommission.TaxType.Code"
                  :class="validatedCommissionForm | showValidateError(invalid)"
                  :value="null"
                  :disabled="isSeeing"
                >
                  <option :value="null" selected>Selecione</option>
                  <option
                    v-for="type in taxTypes"
                    v-bind:key="type.Code"
                    v-bind:value="type.Code"
                  >
                    {{ type.Name }}
                  </option>
                </d-select>
                <div
                  class="invalid-feedback d-block"
                  v-if="validatedCommissionForm"
                >
                  {{ errors[0] }}
                </div>
              </ValidationProvider>
            </d-col>
            <d-col md="6" class="form-group">
              <label v-if="infoCommission.TaxType.Code == 1">Percentual</label>
              <label v-else>Valor</label>
              <ValidationProvider
                rules="required|min_value:0.01"
                v-slot="{ errors, invalid }"
              >
                <decimal-field
                  v-model="infoCommission.Tax"
                  :class="validatedCommissionForm | showValidateError(invalid)"
                  :disabled="isSeeing"
                  :type="
                    infoCommission.TaxType.Code == 1 ? 'percentage' : 'currency'
                  "
                />
                <div
                  class="invalid-feedback d-block"
                  v-if="validatedCommissionForm"
                >
                  {{ errors[0] }}
                </div>
              </ValidationProvider>
            </d-col>
          </d-form-row>
          <d-form-row>
            <d-col md="6" class="form-group">
              <label>Comissão</label>
              <ValidationProvider rules="required" v-slot="{ errors, invalid }">
                <decimal-field
                  v-model="infoCommission.Commission"
                  :class="validatedCommissionForm | showValidateError(invalid)"
                  :disabled="isSeeing"
                  :type="'percentage'"
                />
                <div
                  class="invalid-feedback d-block"
                  v-if="validatedCommissionForm"
                >
                  {{ errors[0] }}
                </div>
              </ValidationProvider>
            </d-col>
          </d-form-row>
        </ValidationObserver>
      </div>

      <template slot="modal-footer" slot-scope="{ cancel }">
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button size="sm" @click="cancel()">Fechar</b-button>
        <b-button
          size="sm"
          variant="success"
          @click="SaveCommission()"
          v-if="!isSeeing || (isSeeing && loadingAddUpdate)"
          :disabled="loadingAddUpdate || loadingModal"
        >
          <template v-if="!loadingAddUpdate">
            {{ idOpened != null ? " Salvar" : " Adicionar" }}
            <i class="fas fa-arrow-right"></i>
          </template>
          <template v-else>
            <loader :small="true" :isLoading="loadingAddUpdate"></loader>
          </template>
        </b-button>
      </template>
    </b-modal>

    <b-modal
      id="mFilter"
      title="Filtros"
      centered
      :no-close-on-backdrop="true"
      :no-close-on-esc="false"
    >
      <d-form-row>
        <d-col md="6" class="form-group">
          <d-select v-model="filter.CodeTaxType" :value="null">
            <option :value="null" selected>Tipo de taxa</option>
            <option
              v-for="type in taxTypes"
              v-bind:key="type.Code"
              v-bind:value="type.Code"
            >
              {{ type.Name }}
            </option>
          </d-select>
        </d-col>
        <d-col md="6" class="form-group">
          <d-select v-model="filter.CodePartnerType" :value="null">
            <option :value="null" selected>Tipo de parceiro</option>
            <option
              v-for="type in partnerTypes"
              v-bind:key="type.Code"
              v-bind:value="type.Code"
            >
              {{ type.Name }}
            </option>
          </d-select>
        </d-col>
        <d-col md="6" class="form-group">
          <d-select v-model="filter.CodePaymentMethod" :value="null">
            <option :value="null" selected>Método de pagamento</option>
            <option
              v-for="type in paymentMethods"
              v-bind:key="type.Code"
              v-bind:value="type.Code"
            >
              {{ type.Name }}
            </option>
          </d-select>
        </d-col>
        <d-col md="6" class="form-group">
          <d-select v-model="filter.IsRemoved" :value="null">
            <option :value="false">Ativos</option>
            <option :value="true">Inativos</option>
          </d-select>
        </d-col>
      </d-form-row>

      <template slot="modal-footer">
        <b-button
          variant="primary"
          class="btn btn-primary"
          v-b-tooltip.hover.bottom
          title="Pesquisar"
          @click="Filter()"
        >
          <i class="fas fa-search"></i>
        </b-button>
        <b-button
          variant="primary"
          class="input-group-text"
          v-b-tooltip.hover.bottom
          title="Limpar filtros"
          @click="ResetFilter()"
        >
          <i class="fas fa-eraser"></i>
        </b-button>
      </template>
    </b-modal>

    <a
      v-if="$isAuthorize('CommissionCompetence', 'Add')"
      href="#"
      class="btn-float success"
      v-b-tooltip.hover
      title="Nova comissão"
      v-on:click="OpenNewCommission($event)"
    >
      <i class="fa fa-plus"></i>
    </a>
  </div>
</template>

<script>
import DecimalField from "../common/decimal-field.vue";
import { hasValue } from "../../utils/functions.js";
export default {
  name: "commissions",
  components: {
    DecimalField,
  },
  data: function () {
    return {
      loadingAddUpdate: false,
      loadingList: false,
      loadingModal: false,
      countFilter: 0,
      modalTitle: "Nova comissão",
      pagination: {
        RowsPerPage: 10,
        PageNumber: 1,
        TotalItems: 0,
      },
      filter: {
        CodePaymentMethod: null,
        CodeTaxType: null,
        CodePartnerType: null,
        IsRemoved: false,
      },
      idOpened: null,
      isSeeing: false,
      commissions: [],
      infoCommission: {
        PartnerType: {
          Code: null,
        },
        PaymentMethod: {
          Code: null,
        },
        TaxType: {
          Code: null,
        },
        Tax: null,
        Commission: null,
      },
      partnerTypes: [],
      paymentMethods: [],
      taxTypes: [],
      validatedCommissionForm: false,
    };
  },
  computed: {},
  watch: {
    "pagination.PageNumber": function () {
      this.ListCommissionCompetence();
    },
    "pagination.RowsPerPage": function () {
      this.ListCommissionCompetence();
    },
  },
  mounted() {
    this.ListCommissionCompetence();
    this.$store
      .dispatch("ListPartnerType")
      .then((response) => {
        this.partnerTypes = response;
      })
      .catch((error) => {
        this.$makeToast(
          undefined,
          "danger",
          "Erro ao obter a lista com os tipos de parceiro",
          error
        );
      });

    this.$store
      .dispatch("ListPaymentMethodIsEnabled")
      .then((response) => {
        this.paymentMethods = response.Objects;
      })
      .catch((error) => {
        this.$makeToast(
          undefined,
          "danger",
          "Erro ao obter a lista com os métodos de pagamento",
          error
        );
      });

    this.$store
      .dispatch("ListTaxType")
      .then((response) => {
        this.taxTypes = response;
      })
      .catch((error) => {
        this.$makeToast(
          undefined,
          "danger",
          "Erro ao obter a lista com os tipos de taxas",
          error
        );
      });
  },
  methods: {
    OpenModalFilter: function () {
      this.$bvModal.show("mFilter");
    },
    Filter: function () {
      this.$bvModal.hide("mFilter");
      this.ListCommissionCompetence();
    },
    ShowCommission: function () {
      this.$bvModal.show("mFormCommission");
    },
    HideCommissionCompetence: function () {
      this.$bvModal.hide("mFormCommission");
    },
    OpenNewCommission: function () {
      this.ResetCommission();
      this.idOpened = null;
      this.isSeeing = false;
      this.validatedCommissionForm = false;
      this.modalTitle = "Nova comissão";
      this.ShowCommission();
    },
    ResetFilter: function () {
      this.filter = {
        CodePaymentMethod: null,
        CodeTaxType: null,
        CodePartnerType: null,
        IsRemoved: false,
      };
      this.ListCommissionCompetence();
    },
    ResetCommission: function () {
      this.infoCommission = {
        PartnerType: {
          Code: null,
        },
        PaymentMethod: {
          Code: null,
        },
        TaxType: {
          Code: null,
        },
        Tax: null,
        Commission: null,
      };
    },
    DeleteCommissionCompetence: function (i, disable) {
      let commissionAux = this.commissions[i];

      this.$makeMsgBox(
        `Você tem certeza que deseja ${
          disable ? "desativar" : "ativar"
        } esta comissão?`,
        "Confirmar ação",
        this.UpdateRemovedCommission,
        commissionAux,
        disable
      );
    },
    UpdateRemovedCommission: function (commissionAux, disable) {
      let label = disable ? "desativada" : "ativada";
      let commissionRemoved = {
        Id: commissionAux.Id,
        IsRemoved: disable,
      };
      this.$store
        .dispatch("DeleteCommissionCompetence", commissionRemoved)
        .then(() => {
          this.ListCommissionCompetence();
          this.$bvModal.hide("mFormCommission");

          this.$makeToast(
            `A comissão foi ${label}`,
            "success",
            `Comissão ${label}`
          );
        })
        .catch((error) => {
          this.$makeToast(
            undefined,
            "danger",
            `Falha ao ${disable ? "desativar" : "ativar"}.`,
            error
          );
        });
    },
    GetCommissionCompetence: function (e, id, seeing) {
      e.preventDefault();
      this.loadingModal = true;
      this.validatedCommissionForm = false;
      this.idOpened = id;

      if (typeof seeing != "undefined") {
        this.isSeeing = true;
        this.modalTitle = "Detalhes da comissão";
      } else {
        this.isSeeing = false;
        this.modalTitle = "Editar comissão";
      }

      this.ShowCommission();
      this.ResetCommission();

      this.$store
        .dispatch("GetCommissionCompetence", { id: id })
        .then((response) => {
          this.infoCommission = response;
        })
        .catch((error) => {
          this.$makeToast(
            undefined,
            "danger",
            "Erro ao carregar a comissão",
            error
          );
        })
        .finally(() => {
          this.loadingModal = false;
        });
    },
    ListCommissionCompetence: function () {
      this.countFilter = 0;
      if (hasValue(this.filter.CodePaymentMethod)) this.countFilter++;
      if (hasValue(this.filter.CodeTaxType)) this.countFilter++;
      if (hasValue(this.filter.CodePartnerType)) this.countFilter++;
      if (hasValue(this.filter.IsRemoved)) this.countFilter++;
      this.loadingList = true;
      let data = {
        ...this.pagination,
        ...{
          "Object.PaymentMethod.Code": this.filter.CodePaymentMethod,
          "Object.TaxType.Code": this.filter.CodeTaxType,
          "Object.PartnerType.Code": this.filter.CodePartnerType,
          "Object.IsRemoved": this.filter.IsRemoved,
        },
      };
      delete data.TotalItems;
      this.$store
        .dispatch("ListCommissionCompetence", { params: data })
        .then((response) => {
          this.commissions = response.Objects;
          this.pagination.TotalItems = response.TotalItems;
        })
        .catch((error) => {
          this.$makeToast(
            undefined,
            "danger",
            "Erro ao listar as comissões",
            error
          );
        })
        .finally(() => (this.loadingList = false));
    },
    SaveCommission: function () {
      this.validatedCommissionForm = true;

      this.$refs.CommissionsValidationForm.validate().then((isValid) => {
        if (isValid) {
          this.loadingAddUpdate = true;
          this.isSeeing = true;
          if (!this.idOpened) {
            this.$store
              .dispatch("AddCommissionCompetence", this.infoCommission)
              .then(() => {
                this.$makeToast(
                  "A comissão foi cadastrada corretamente na base de dados",
                  "success",
                  "Comissão cadastrada"
                );
                this.ListCommissionCompetence();
                this.HideCommissionCompetence();
              })
              .catch((error) => {
                this.$makeToast(
                  undefined,
                  "danger",
                  "Erro ao criar a comissão",
                  error
                );
              })
              .finally(() => {
                this.loadingAddUpdate = false;
                this.isSeeing = false;
              });
          } else {
            this.$store
              .dispatch("UpdateCommissionCompetence", this.infoCommission)
              .then(() => {
                this.$makeToast(
                  "Suas modificações foram salvas na base de dados",
                  "success",
                  "Comissão alterada"
                );
                this.ListCommissionCompetence();
                this.HideCommissionCompetence();
              })
              .catch((error) => {
                this.$makeToast(
                  undefined,
                  "danger",
                  "Erro ao atualizar a comissão",
                  error
                );
              })
              .finally(() => {
                this.loadingAddUpdate = false;
                this.isSeeing = false;
              });
          }
        }
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pages/commissions.vue